export default "__VITE_ASSET__Syivd$UF__"